import { createSyncClientFlag } from "@/lib/core/client-flags/create-sync-client-flag";

const TEXT_KITS_EXPLAINER_ENABLED = false;
const PARAM = "textKitsExplainer";

export const useTextKitsExplainerEnabled = createSyncClientFlag({
    param: PARAM,
    key: "text-kits-explainer",
    env: TEXT_KITS_EXPLAINER_ENABLED,
});

export const textKitsExplainerForced =
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).get(PARAM) === "1";
